import { IonAccordion, IonCol, IonIcon, IonRow, IonText } from "@ionic/react";
import { ItemsTechno, jobs } from "../../variables/jobsDictionnary";
import Pole from "./Pole";
import { activeItem, disabledItem } from "./welcomeInterface";

interface Props {
  item: ItemsTechno;
  index: number;
  depth: number;
}

const ItemTechno: React.FC<Props> = ({ item, index, depth }) => {
  return (
    <IonAccordion
      color="danger"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <div slot="header">
        <IonCol
          size={item.size ?? "12"}
          className={"clickable " + (depth === 2 ? "ion-no-padding" : "")}
          style={{
            minHeight: "100%",
            paddingBottom: depth === 2 ? 5 : "",
          }}
          onClick={(e) => {
            e.stopPropagation();

            if (item.title.length <= 0) return;

            const itemTrigger = item;

            if (itemTrigger.disabled === true) return;
            if (itemTrigger.href && itemTrigger.href.length > 0) {
              window.location.href = itemTrigger.href;
            }
          }}
        >
          {item.hasChild ? (
            <IonCol className="ion-no-padding ">
              <IonRow>
                {item.children?.map((child, key) => {
                  return (
                    <ItemTechno
                      key={key}
                      item={child}
                      index={3}
                      depth={depth + 1}
                    />
                  );
                })}{" "}
              </IonRow>
            </IonCol>
          ) : (
            <>
              <IonRow
                className={
                  "ion-align-items-center " +
                  (item.primary
                    ? "ion-justify-content-start"
                    : "ion-justify-content-center")
                }
                style={{
                  backgroundColor: item.backgroundColor,
                  height: item.primary ? "" : "100%",
                  minHeight: item.secondary ? 60 : "",
                  border: "1px solid black",
                  borderBottom: item.primary ? "none" : "1px solid black",
                }}
              >
                {item.secondary && (
                  <IonIcon
                    icon={item.icon}
                    size="large"
                    color="black"
                    style={{ padding: 4 }}
                  />
                )}
                <IonText
                  className="txtPart black-text"
                  style={
                    item.primary
                      ? { padding: "2px 0px 2px 30px" }
                      : { textAlign: "center" }
                  }
                >
                  <h1
                    className="fit-content"
                    style={
                      item.secondary
                        ? {
                            fontSize: 21,
                          }
                        : {}
                    }
                  >
                    {item.title.split("(")[0]}
                    {item.title.split("(")[1] && (
                      <span style={{ fontSize: 14 }}>
                        {"(" + item.title.split("(")[1]}
                      </span>
                    )}
                  </h1>
                </IonText>
              </IonRow>
              {item.primary && (
                <IonRow
                  style={
                    item.disabled
                      ? disabledItem(item.icon)
                      : activeItem(item.icon)
                  }
                ></IonRow>
              )}
            </>
          )}
        </IonCol>
      </div>
      <div slot="content">
        {jobs.get(localStorage.getItem("techno") ?? "")?.poles(index) !==
          undefined && (
          <IonRow className="fullWidth ion-text-center ion-no-padding pole ion-justify-content-center">
            {jobs
              .get(localStorage.getItem("techno") ?? "")
              ?.poles(index)
              ?.map((pole, i, arr) => {
                return (
                  <Pole
                    arrayLength={arr.length}
                    href={pole.href}
                    pole={pole}
                    key={i}
                  />
                );
              })}
          </IonRow>
        )}
      </div>
    </IonAccordion>
  );
};

export default ItemTechno;
